export default [
  {
    question: `What do I need to know?`,
    answer: `Staking via Unagii delegates KNC to the Stakewithus Poolmaster contract, allowing us to vote on your behalf and receive a share of the trading fees. Rewards are earned by staking tokens and are automatically recompounded into KNC. Users can withdraw at any time.`,
  },
  {
    question: `What is the inflation?`,
    answer: `N/A`,
  },
  {
    question: `Is there a lock-up period?`,
    answer: `There is no lock-up period. No rewards are earned when you unstake during an epoch.`,
  },
  {
    question: `How to restake?`,
    answer: `KNC rewards are automatically restaked and compounded until unstaked.`,
  },
  {
    question: `Is there a fee?`,
    answer: `There is a 0.1% withdrawal fee set to prevent front running attacks when the Poolmaster claims the rewards for users at the start of the new epoch. There is no delegation commission fee paid to Stakewithus.`,
  },
  {
    question: `What are the risks?`,
    answer: `Unique to Kyber, there are no slashing risks involved for delegation.`,
  },
];
